import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";


interface AppState {
  currentSpace: 'admin' | 'user';
  health: 'true' | 'false' | 'license-false'
}

const initialState: AppState = {
    currentSpace: 'user',
    health: 'license-false'
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setCurrentSpace: (state, actions) => {
      state.currentSpace = actions.payload;
    },
    setHealth: (state, actions) => {
      state.health = actions.payload;
    }
  },
});

